// extracted by mini-css-extract-plugin
export default {"TitleRow":"Datasheet_TitleRow__B4S++","SubTitleRow":"Datasheet_SubTitleRow__GuB3r"};